import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette }) =>
  createStyles({
    container: {
      display: 'flex',

      '& > :nth-child(1)': {
        minWidth: '20rem',
        margin: 0,

        backgroundColor: palette.background.default,

        '& > .MuiOutlinedInput-root': {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,

          '& svg': {
            color: palette.secondary.main,
          },
        },
      },

      '& > :nth-child(2)': {
        width: '100%',
        margin: 0,

        '& > .MuiOutlinedInput-root': {
          borderRadius: 0,
          '&:not(.Mui-focused) > fieldset': {
            borderInline: 0,
          },
        },

        '& svg': {
          color: palette.secondary.main,
        },
      },

      '& > button': {
        width: 'auto',
        height: '4.8rem',
        margin: 0,
        padding: '0 2.7rem',

        backgroundColor: palette.background.default,

        border: `1px solid ${palette.secondary.light}`,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      },
    },

    menuList: {
      border: `1px solid ${palette.secondary.light}`,
      borderTop: 0,
      borderTopRightRadius: 0,

      '& ul': {
        padding: 0,
      },
    },

    menuItem: {
      borderBottom: `1px solid ${palette.secondary.light}`,
      paddingBlock: 8,

      '&:last-child': {
        borderBottom: 'none',
      },

      '&.Mui-selected': {
        color: '#727970',
        backgroundColor: 'transparent',
      },
    },
  }),
)
